export const SET_USER = 'set_user';
export const SET_PERMISSIONS = 'set_permissions';
export const SET_PERMISSIONS_LOADED = 'set_permissions_loaded';
export const SET_ANONYMOUS_TOKEN = 'set_anonymous_token';
export const SET_USER_TOKEN = 'set_user_token';

export const state = () => ({
  anonymousToken: null,
  userToken: null,
  user: null,
  permissions: [],
  permissionsLoaded: false,
});

export const actions = {
  resetUser ({ commit }) {
    commit(SET_USER, null);
    commit(SET_PERMISSIONS, []);
    commit(SET_PERMISSIONS_LOADED, false);
  },

  me ({ commit, dispatch }, config = {}) {
    return this.$getDataProvider('/me').getOne('', { config })
      .then(({ data }) => {
        commit(SET_USER, data.user);
        commit(SET_PERMISSIONS, data.permissions);
        commit(SET_PERMISSIONS_LOADED, true);
      })
      .catch(() => {
        dispatch('resetUser');
      });
  },

  changePassword (context, { oldPassword, newPassword }) {
    return this.$getDataProvider('/me/change-password')
      .create('', {
        data: {
          oldPassword,
          newPassword,
        },
      });
  },

  setAnonymousToken ({ commit }, token) {
    commit(SET_ANONYMOUS_TOKEN, token);
  },

  setUserToken ({ commit }, token) {
    commit(SET_USER_TOKEN, token);
  },
};

export const mutations = {
  [SET_USER] (state, payload) {
    state.user = payload;
  },

  [SET_PERMISSIONS] (state, payload) {
    state.permissions = payload;
  },

  [SET_PERMISSIONS_LOADED] (state, payload) {
    state.permissionsLoaded = payload;
  },

  [SET_ANONYMOUS_TOKEN] (state, payload) {
    state.anonymousToken = payload;
  },

  [SET_USER_TOKEN] (state, payload) {
    state.userToken = payload;
  },
};

export const getters = {
  getAnonymousToken: (state) => {
    return state.anonymousToken || null;
  },

  getUserToken: (state) => {
    return state.userToken || null;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
